import { post } from '@/request';

const mailApi = {
  sendMail(data) {
    return post('/gt/mail/zlb/send', data);
  }
};
export default mailApi;
